// extracted by mini-css-extract-plugin
export default {"wrapper":"reportTile_wrapper__xwBB7","title":"reportTile_title__TY1CJ","date":"reportTile_date__G33OE"};